import { render, staticRenderFns } from "./UnAuthorized.vue?vue&type=template&id=51c9bd4f&scoped=true"
import script from "./UnAuthorized.vue?vue&type=script&lang=js"
export * from "./UnAuthorized.vue?vue&type=script&lang=js"
import style0 from "./UnAuthorized.vue?vue&type=style&index=0&id=51c9bd4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c9bd4f",
  null
  
)

export default component.exports